import styled from 'styled-components';
import { rem } from 'polished';
import GeneralItem from '../../core/GeneralList/GeneralItem';

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledDate = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.dark};
  padding: ${rem('5px')};
  text-align: center;
  width: ${rem('56px')};
  height: ${rem('56px')};
`;

const StyledDay = styled.span`
  color: ${props => props.theme.colors.light};
  font-size: ${rem('15px')};
  font-family: ${props => props.theme.fonts.medium};
  text-transform: uppercase;
  line-height: ${rem('21px')};
`;

const StyledNumber = styled(StyledDay)`
  font-size: ${rem('23px')};
`;

const StyledGeneralItem = styled(GeneralItem)`
  width: calc(100% - 56px);
  background-color: ${props => props.theme.colors.grayLightest};

  .GeneralItem-text {
    font-family: ${props => props.theme.fonts.bold};
    font-size: ${rem('16px')};
  }
`;

export {
  StyledWrapper,
  StyledDate,
  StyledDay,
  StyledNumber,
  StyledGeneralItem
};
